import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h3", { class: "leading-6 font-medium text-gray-900" }, "Typical working week:", -1);
const _hoisted_2 = /*#__PURE__*/ _createStaticVNode("<div class=\"flex\"><div class=\"flex-1 mx-2\"></div> <div class=\"flex-1 mx-2\">Start</div> <div class=\"flex-1 mx-2\">End</div> <div class=\"flex-1 mx-2\">Breaks</div></div>", 1);
const _hoisted_3 = { class: "flex-1 mx-2" };
const _hoisted_4 = { class: "flex-1 mx-2" };
const _hoisted_5 = ["id", "value", "name", "disabled", "onChange"];
const _hoisted_6 = ["value"];
const _hoisted_7 = { class: "flex-1 mx-2" };
const _hoisted_8 = ["id", "value", "name", "disabled", "onChange"];
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "flex-1 mx-2" };
const _hoisted_11 = ["id", "value", "name", "disabled", "onChange"];
const _hoisted_12 = ["value"];
import { ref, toRef } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkingWeek',
    props: {
        data: {},
        disableForm: { type: Boolean }
    },
    emits: ["update", "mark-complete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const model = toRef(props, 'data');
        const days = ref([
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ]);
        // Function to get times at 15 minute intervals to populate dropdowns
        const getAllTimes = () => {
            const arr = ['Off'];
            let hour = 0;
            while (hour < 24) {
                arr.push(`${hour}:00`);
                arr.push(`${hour}:15`);
                arr.push(`${hour}:30`);
                arr.push(`${hour}:45`);
                hour++;
            }
            arr.push('00:00');
            return arr;
        };
        const startEndOptions = getAllTimes();
        const handleInputChange = (event, day, type) => {
            const target = event.target;
            const value = target.value;
            model.value[day.toLowerCase()][type] = value;
            emit('update', { data: model.value });
            if (checkIsComplete())
                emit('mark-complete', true);
            else
                emit('mark-complete', false);
        };
        const checkIsComplete = () => {
            let complete = true;
            days.value.forEach((day) => {
                const dayData = props.data[day.toLowerCase()];
                if (!(dayData.start && dayData.end && dayData.break)) {
                    complete = false;
                }
            });
            return complete;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _hoisted_1,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _hoisted_2,
                    _createTextVNode(),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: day,
                            class: "flex"
                        }, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(day), 1),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("select", {
                                    id: `select-${day}-start`,
                                    value: props.data[day.toLowerCase()].start,
                                    name: `select-${day}-start`,
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                    disabled: _ctx.disableForm,
                                    onChange: ($event) => (handleInputChange($event, day, 'start'))
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(startEndOptions), (time) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: time,
                                            value: time
                                        }, _toDisplayString(time), 9, _hoisted_6));
                                    }), 128))
                                ], 40, _hoisted_5)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("select", {
                                    id: `select-${day}-end`,
                                    value: props.data[day.toLowerCase()].end,
                                    name: `select-${day}-end`,
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                    disabled: _ctx.disableForm,
                                    onChange: ($event) => (handleInputChange($event, day, 'end'))
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(startEndOptions), (time) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: time,
                                            value: time
                                        }, _toDisplayString(time), 9, _hoisted_9));
                                    }), 128))
                                ], 40, _hoisted_8)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("select", {
                                    id: `select-${day}-break`,
                                    value: props.data[day.toLowerCase()].break,
                                    name: `select-${day}-break`,
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                    disabled: _ctx.disableForm,
                                    onChange: ($event) => (handleInputChange($event, day, 'break'))
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(startEndOptions), (time) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: time,
                                            value: time
                                        }, _toDisplayString(time), 9, _hoisted_12));
                                    }), 128))
                                ], 40, _hoisted_11)
                            ])
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
});
